import React from 'react';
import PropTypes from 'prop-types';

import { platformGroupings } from '../../../utils';
import {
  BuoyOutlineIcon, TowerIconV2, VirusIcon, GliderIcon,
} from '../../../components/icons';

const PlatformType = (props) => {
  const { platformType } = props;

  const iconStyle = {
    color: '#4faae2',
    width: 18,
    height: 18,
    fontSize: 18,
  };

  const platformMappings = [
    {
      condition: platformGroupings.buoy.includes(platformType),
      icon: <BuoyOutlineIcon style={iconStyle} />,
      label: 'Buoy',
    },
    {
      condition: platformGroupings.moving.includes(platformType),
      icon: <GliderIcon style={iconStyle} />,
      label: 'Glider',
    },
    {
      condition: platformGroupings.tower.includes(platformType),
      icon: <TowerIconV2 style={iconStyle} />,
      label: 'Tower',
    },
    {
      condition: platformGroupings.sampling_location.includes(platformType),
      icon: <VirusIcon style={iconStyle} />,
      label: 'Sampling Location',
    },
  ];

  const match = platformMappings.find((p) => p.condition);

  if (match) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 6,
          color: '#fff',
        }}
      >
        {match.icon}
        <span
          style={{
            opacity: 0.8,
          }}
        >
          {match.label}
        </span>
      </div>
    );
  }

  return platformType;
};

PlatformType.propTypes = {
  platformType: PropTypes.string,
};

PlatformType.defaultProps = {
  platformType: '',
};

export default PlatformType;
